// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"ModalScrollBar_scrollbar__2JARN","children":"ModalScrollBar_children__2lXsB"};